/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from 'react';

export default {
  title: 'HSBC simplified Chinese English logo',
  viewBox: '0 0 528 143',
  svgContent: (
    <>
      <g id="guides">
        <path
          fill="none"
          d="M212.8,284V142.2l70.9,70.9L212.8,284z M141.9,213.1l70.9-70.9H71L141.9,213.1z M0.2,213.1L71.1,284V142.2
		L0.2,213.1z M141.9,213.1L71,284h141.7L141.9,213.1z M-70.7-70.4l-70.9,70.9H0.1L-70.7-70.4z M-70.7,71.4l-70.9-70.9v141.7
		L-70.7,71.4z M-70.7,213.1l70.9-70.9h-141.8L-70.7,213.1z M-70.7,71.4l70.9,70.9V0.5L-70.7,71.4z M295.4,47.7l-11.7,11.8h23.6
		L295.4,47.7z M295.4,71.3l-11.7-11.8v23.6L295.4,71.3z M295.4,94.9l11.8-11.8h-23.5L295.4,94.9z M295.4,71.3l11.8,11.8V59.5
		L295.4,71.3z M283.7-70.4l-70.9-70.8V0.5L283.7-70.4z M141.9-70.4l70.8-70.9H71L141.9-70.4z M0.2-70.4L71.1,0.5v-141.7L0.2-70.4z
		 M141.9-70.4L71.1,0.5h141.7L141.9-70.4z"
        />
      </g>
      <g id="HSBC_MASTERBRAND_ENG_TC_WW_CMYK">
        <path
          d="M352.6,20.8l4.7-5.5c4.4,2.9,8.4,6.3,12,10.2l-5.2,5.5C360.6,27.2,356.8,23.8,352.6,20.8z M364.3,34.2l7,3.7
		c-2.9,7.9-6.7,15.4-11.2,22.5l-7-4.5C358.1,49.3,361.9,42,364.3,34.2z M354.3,5.1l5-5.2c4.1,2.6,7.9,5.6,11.4,8.9l-5.1,5.8
		C362.3,11,358.5,7.8,354.3,5.1L354.3,5.1z M412.7,8.5h-30.3v43.4h30.8v6.7h-38.1v-57h37.6V8.5z"
        />
        <path
          d="M420.3,39.1h26.1v-8.9h-20.1v-6.7h20.1v-8.9h-24V7.7h24v-7.8h7.6v7.8h24v6.8h-24v8.9h20.1v6.8H454v8.9h26.1v6.8H454v14.4
		h-7.6V46h-26.1V39.1z"
        />
        <rect x="-141.3" y="-141.5" fill="none" width="810.1" height="424.8" />
        <polygon
          fill="#FFFFFF"
          points="213,0 71.3,0 0.4,70.9 71.3,141.8 213,141.8 283.9,70.9 	"
        />
        <polygon fill="#DB0011" points="283.9,70.9 213,0 213,141.8 	" />
        <polygon fill="#DB0011" points="142.2,70.9 213,0 71.3,0 	" />
        <polygon fill="#DB0011" points="0.4,70.9 71.3,141.8 71.3,0 	" />
        <polygon fill="#DB0011" points="142.2,70.9 71.3,141.8 213,141.8 	" />
        <path d="M346.1,116h-25.7v25.4h-12.9V82.1h12.9v24.3h25.7V82.1H359v59.3h-12.9V116z" />
        <path
          d="M389.8,142.7c-12.8,0-23.3-5.1-23.6-19.3h12.9c0.2,6.3,3.9,10.1,10.9,10.1c5.2,0,11.2-2.6,11.2-8.5c0-4.6-4-6.1-10.7-8
		l-4.3-1.2c-9.4-2.7-18.6-6.3-18.6-17c0-13.2,12.3-17.6,23.6-17.6c11.6,0,21.5,4,21.6,17.1h-12.9c-0.5-5.4-3.6-8.5-9.7-8.5
		c-4.8,0-9.5,2.5-9.5,7.8c0,4.4,3.9,5.7,12.3,8.3l4.9,1.6c10.2,3.2,16.6,6.7,16.6,16.6C414.6,137.5,401.5,142.7,389.8,142.7z"
        />
        <path
          d="M421.8,82.3h20.6c6.5,0,9.1,0.2,11.7,0.7c7.2,1.6,12.6,6.3,12.6,14.3c0,7.6-4.8,11.6-11.8,13.4c8,1.5,14,5.6,14,14.4
		c0,13.5-13.3,16.6-23.7,16.6h-23.3L421.8,82.3L421.8,82.3z M442.5,107c5.7,0,11.4-1.1,11.4-8c0-6.2-5.4-7.8-10.6-7.8h-9V107H442.5z
		 M443.7,132.8c6,0,11.9-1.4,11.9-8.6c0-7.1-5.1-8.7-11.2-8.7h-10.2v17.3L443.7,132.8L443.7,132.8z"
        />
        <path
          d="M502.4,142.7c-19.1,0-27.8-12.2-27.8-30.3c0-17.9,9.5-31.3,28.4-31.3c11.8,0,23.3,5.2,23.6,18.7h-13.3
		c-0.7-5.9-4.6-9-10.3-9c-11.6,0-15.1,12.5-15.1,22c0,9.5,3.5,20.4,14.7,20.4c5.8,0,10.1-3.1,11-9.1H527
		C525.6,137.7,514.8,142.7,502.4,142.7z"
        />
      </g>
    </>
  ),
};
